import 'fslightbox';

const InitFsLightbox = parent => {
    const selectorsToMatch = [
        'a[rel^=lightbox]',
        'a.lightbox',
        'a[href$=jpg]',
        'a[href$=JPG]',
        'a[href$=jpeg]',
        'a[href$=JPEG]',
        'a[href$=png]',
        'a[href$=PNG]',
        'a[href$=webp]',
        'a[href$=WEBP]',
    ];

    for(var el of document.querySelectorAll(selectorsToMatch.join(','))) {
        if(el.classList.contains('no-lightbox')) {
            continue;
        }

        el.dataset.fslightbox = 'gallery';
    }

    refreshFsLightbox();

    const slideShowCallback = function(i) {
        var el = fsLightbox.elements.sourceAnimationWrappers[i];
        if(el) {
            var dl = window.dataLayer||null;
            var l = location.pathname=='/' ? 'homepage/lightbox' : location.pathname.replace(/\/$/, '') + '/lightbox';
            dl&&dl.push({
                'event':'ga.pageview', 
                'GA-VPAGE-TITLE':'Lightbox / '+document.title, 
                'GA-VPAGE-URL':l
            });

        }
        if(el && el.querySelector('IMG.fslightbox-source') && !el.querySelector('.fslightbox-source-caption')) {
            var el2 = document.createElement('div');
            el2.classList.add('fslightbox-source-caption');
            el2.innerText = fsLightbox.elements.a[i].dataset.lightboxTitle||fsLightbox.elements.a[i].dataset.title||fsLightbox.elements.a[i].title||'Kopiowanie zdjeć bez zgody autora zabronione';
            if(!el.querySelector('.fslightbox-source-caption')) {
                el.parentNode.appendChild(el2);
            }
        }
    }
    
    if(fsLightbox) {
        fsLightbox.props.onOpen = function(){
            if(!fsLightbox._loaded_) {
                const oldJumpToCallback = fsLightbox.core.slideIndexChanger.jumpTo;
                fsLightbox.core.slideIndexChanger.jumpTo = function(i) {
                    oldJumpToCallback(i);
                    slideShowCallback(i);
                }
                fsLightbox._loaded_ = true;
            }
            setTimeout(() => {
                var i = fsLightbox.core.stageManager.getNextSlideIndex();
                i = i>1 ? i-1 : 0;
                slideShowCallback(i);
            },500);
        };
    }
};

InitFsLightbox()

// eslint-disable-next-line import/prefer-default-export
export { InitFsLightbox };
